import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fuse-feedback-customer-filter',
  templateUrl: './feedback-customer-filter.component.html',
  styleUrls: ['./feedback-customer-filter.component.scss']
})
export class FeedbackCustomerFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }
}
